import { render, staticRenderFns } from "./PublishPresentations.vue?vue&type=template&id=491b5bb8&scoped=true&"
import script from "./PublishPresentations.vue?vue&type=script&lang=js&"
export * from "./PublishPresentations.vue?vue&type=script&lang=js&"
import style0 from "./PublishPresentations.vue?vue&type=style&index=0&id=491b5bb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491b5bb8",
  null
  
)

export default component.exports